import React from 'react';
import { motion } from 'framer-motion';
import { FaLightbulb, FaChartLine, FaUsers, FaAward, FaRocket, FaGlobe, FaHandshake, FaHandsHelping } from 'react-icons/fa';

const AboutCompany = () => {
  const coreValues = [
    {
      icon: <FaLightbulb className="text-red-600 text-5xl mb-4" />,
      title: "Innovation",
      description: "To work towards perfection with the right resources and execution."
    },
    {
      icon: <FaChartLine className="text-red-600 text-5xl mb-4" />,
      title: "Passion",
      description: "To follow commitment and desire for continuous growth."
    },
    {
      icon: <FaUsers className="text-red-600 text-5xl mb-4" />,
      title: "Teamwork",
      description: "We believe that we all succeed together. Teamwork is important for achieving great success."
    },
    {
      icon: <FaAward className="text-red-600 text-5xl mb-4" />,
      title: "Quality Service",
      description: "Provide excellent service to our customers that we are proud to stand behind."
    },
    {
      icon: <FaRocket className="text-red-600 text-5xl mb-4" />,
      title: "Future Centric",
      description: "Shaping tomorrow with innovative, future-centric solutions."
    },
    {
      icon: <FaGlobe className="text-red-600 text-5xl mb-4" />,
      title: "Global",
      description: "Delivering world-class solutions with a global perspective."
    },
    {
      icon: <FaHandshake className="text-red-600 text-5xl mb-4" />,
      title: "Commitment",
      description: "Driven by a steadfast commitment to quality and excellence."
    },
    {
      icon: <FaHandsHelping className="text-red-600 text-5xl mb-4" />,
      title: "Social",
      description: "Engaging communities through meaningful social initiatives and impact."
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      {/* Company Info Section */}
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
          India's Leading CED Coating Company Recognized for Expertise and Superior Technical Capabilities
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed max-w-4xl mx-auto">
          We are “CED Coatings” one of the India’s well recognised CED Coating Company under expert guidance and great technical capabilities. Headquarter is located in New Delhi. We are consistently progressing. Our clients are extremely satisfied by our service. They seek our services repetitively. We have an excellent pool of highly skilled engineering resources & high quality manufacturing units to ensure best service. Our team is having more than two decades of hands-on experience in the various fields of Industrial Coating and Engineering & Integration Process. We have the latest Project management resources, dedicated Vendor base for building plant with the advanced Technologies for all CED and Powder Coating Systems.
        </p>
      </motion.div>

      {/* Core Values Section */}
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 border-b-2 inline-block border-red-600 pb-2">
          Core Values
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {coreValues.map((value, index) => (
          <motion.div
            key={index}
            className="flex flex-col items-center text-center p-6 bg-gray-50 rounded-xl shadow hover:shadow-lg transition-all duration-300"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
          >
            {value.icon}
            <h3 className="text-xl font-semibold text-red-600 mb-2">{value.title}</h3>
            <p className="text-gray-600 text-sm">{value.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AboutCompany;
